import { state } from '@/store/vehicle/state';
import { getters } from '@/store/vehicle/getters';
import { actions } from '@/store/vehicle/actions';
import { mutations } from '@/store/vehicle/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
